/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Team_Manager_Remove_User_From_Group_FailedInputs */



/**
* | output |
* | --- |
* | "Error removing user from group. {error}" |
*
* @param {Team_Manager_Remove_User_From_Group_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_remove_user_from_group_failed = /** @type {((inputs: Team_Manager_Remove_User_From_Group_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Remove_User_From_Group_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Erreur lors du retrait de l’utilisateur du groupe. ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Fehler beim Entfernen des Benutzers aus der Gruppe. ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Errore durante la rimozione dell'utente dal gruppo. ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Ошибка при удалении пользователя из группы. ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Error al eliminar usuario del grupo. ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`从组中移除用户时出错。${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`グループからユーザーを削除中にエラーが発生しました。${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`समूह से उपयोगकर्ता को हटाने में त्रुटि। ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Erro ao remover o usuário do grupo. ${i?.error}`)
	return /** @type {LocalizedString} */ (`Error removing user from group. ${i?.error}`)
});